import PropTypes from 'prop-types';
import UIList from 'UIComponents/list/UIList';
// @ts-expect-error untyped dependency
import { useCustomDashboardLimit } from 'dashboard-components/context/use-custom-dashboard-limit';
// @ts-expect-error untyped dependency
import { AsyncHSFSAlerts } from '../pql/AsyncAddonUpgrades';
import { jsx as _jsx } from "react/jsx-runtime";
const DashboardBanners = ({
  customDashboardCount
}) => {
  const customDashboardLimit = useCustomDashboardLimit();
  const reachedLimit = customDashboardLimit !== 0 && customDashboardCount >= customDashboardLimit;
  if (reachedLimit) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIList, {
    children: /*#__PURE__*/_jsx(AsyncHSFSAlerts, {}, "hsfs")
  });
};
DashboardBanners.propTypes = {
  customDashboardCount: PropTypes.number
};
export default DashboardBanners;